'use strict';
import isString from 'lodash/isString';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {I18nComponent} from '../../core-utilities/react-i18n/I18nComponent';

export function BasePopoverSelectView(props) {
  return (
    <div
      className={classNames('PopoverSelect', props.className, {
        PopoverSelect_disabled: props.disabled && !props.readOnly,
        PopoverSelect_readOnly: props.readOnly,
        PopoverSelect_saving: props.isSaving,
      })}
      title={props.title}
      onClick={props.onClick}
    >
      <div className="PopoverSelect__content">
        {BasePopoverSelectView.getIcon(props)}
        {BasePopoverSelectView.getLabel(props)}
        {props.readOnly ? null : (
          <i
            className={classNames('PopoverSelect__arrow', {
              PopoverSelect__arrow_disabled: props.disabled || props.isSaving,
            })}
          />
        )}
      </div>
    </div>
  );
}

BasePopoverSelectView.propTypes = {
  className: T.string,
  labelClassName: T.string,
  text: T.string,
  icon: T.string,
  title: T.string,
  isSaving: T.bool.isRequired,
  disabled: T.bool,
  readOnly: T.bool,
  showText: T.bool,
  showIcon: T.bool,
  onClick: T.func.isRequired,

  nullLabel: T.string,
};

BasePopoverSelectView.defaultProps = {
  className: '',
  labelClassName: '',
  disabled: false,
  readOnly: false,
  showText: true,
  showIcon: true,
};

export const PopoverSelectView = I18nComponent(BasePopoverSelectView, [
  {prop: 'nullLabel', dynamic: getNullLabel},
]);

PopoverSelectView.getIcon = BasePopoverSelectView.getIcon = function (props) {
  return props.showIcon && props.icon ? <i className={`PopoverSelect__icon ${props.icon}`} /> : null;
};

PopoverSelectView.getLabel = BasePopoverSelectView.getLabel = function (props) {
  if (props.showText) {
    const labelClasses = classNames('PopoverSelect__label', props.labelClassName, {
      // 'popover-select-saving': props.isSaving,
    });
    return (
      <span className={labelClasses}>
        {isString(props.text) ? props.text : props.nullLabel}
      </span>
    );
  } else {
    return '';
  }
};

function getNullLabel(props) {
  return props.nullLabel;
}



// WEBPACK FOOTER //
// ./src/js/core-components/popover-select/PopoverSelectView.js